module.exports = __webpack_public_path__ + "static/media/coins-refpay.fb47bda4.svg";